(() => {
  if (window.d1GuaranteeScrollReady) return;
  window.d1GuaranteeScrollReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-d1-guarantee-scroll]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(trigger.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    let parent = target;
    while (parent) {
      if (parent instanceof HTMLDetailsElement) parent.open = true;
      parent = parent.parentElement;
    }
    requestAnimationFrame(() => {
      const focusTarget = target.matches('details') ? target.querySelector('.d1-guarantee-content') : target;
      focusTarget?.focus({ preventScroll: true });
      const drawer = target.closest('.drawer');
      let scroller = target.parentElement;
      while (scroller && scroller !== document.body) {
        if (/(auto|scroll)/.test(getComputedStyle(scroller).overflowY) && scroller.scrollHeight > scroller.clientHeight) break;
        scroller = scroller.parentElement;
      }
      const innerScroll = drawer && scroller && scroller !== document.body;
      let cancelled = false;
      const cancel = () => { cancelled = true; };
      const eventTypes = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
      eventTypes.forEach(type => document.addEventListener(type, cancel, { once: true, passive: true }));
      const align = () => {
        if (cancelled || !target.isConnected) return;
        const rect = target.getBoundingClientRect();
        if (innerScroll) {
          scroller.scrollTo({ top: scroller.scrollTop + rect.top - scroller.getBoundingClientRect().top - 16, behavior: 'instant' });
        } else {
          const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 100;
          window.scrollTo({ top: window.scrollY + rect.top - margin, behavior: 'instant' });
        }
      };
      align();
      requestAnimationFrame(() => requestAnimationFrame(align));
      [200, 600, 1200].forEach(delay => setTimeout(align, delay));
      setTimeout(() => eventTypes.forEach(type => document.removeEventListener(type, cancel)), 1300);
    });
  });
})();
